// src/components/common/BrandColorsInjector/BrandColorsInjector.js
// Injects brand colors from Firestore into CSS variables

import { useEffect } from 'react';
import { DEFAULT_STORE_ID } from '../../../firebase/firebase';
import { getStoreSettings } from '../../../firebase/settings-functions';

const BrandColorsInjector = () => {
    useEffect(() => {
        const loadAndApplyColors = async () => {
            try {
                const settings = await getStoreSettings(DEFAULT_STORE_ID, { simplified: true });

                if (settings.brandColors) {
                    // Convert hex to RGB for CSS variables
                    const hexToRgb = (hex) => {
                        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                        return result
                            ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
                            : '24, 41, 87'; // fallback
                    };

                    // Apply colors to CSS variables
                    document.documentElement.style.setProperty(
                        '--theme',
                        `rgb(${hexToRgb(settings.brandColors.primary)})`
                    );
                    document.documentElement.style.setProperty(
                        '--hover',
                        `rgb(${hexToRgb(settings.brandColors.hover)})`
                    );
                    document.documentElement.style.setProperty(
                        '--font',
                        `rgb(${hexToRgb(settings.brandColors.text)})`
                    );
                    document.documentElement.style.setProperty(
                        '--themel',
                        `rgb(${hexToRgb(settings.brandColors.light)})`
                    );

                    // console.log('✅ Brand colors applied from Firestore');
                }
            } catch (error) {
                console.error('Failed to load brand colors:', error);
                // Fallback colors are already defined in CSS
            }
        };

        loadAndApplyColors();
    }, []);

    return null; // This component doesn't render anything
};

export default BrandColorsInjector;
